import React, { Component } from "react";
import { Link } from "react-router-dom";
import { auth } from "./Firebase";
import { signOut } from "firebase/auth";

class NavBarLogin extends Component {
	logout() {
		signOut(auth);
	}

	checkLogIn() {
		const user = auth.currentUser;
		if (user) {
			return (
				<>
                    {/* These need to be protected */}
                    <Link to="/makepost" className="active">
                        Make A Post
                    </Link>
                    <Link to="/delpost" className="active">
                        Delete A Post
                    </Link>
					<Link to="/Login" onClick={this.logout} className="Register">
						Logout
					</Link>
				</>
			);
		} else {
			return (
				<>
					<Link to="/Login" className="login">
						Login
					</Link>
				</>
			);
		}
	}

	render() {
		return (
			<>
				{/*Top Login/Register navigation bar*/}
				
					{this.checkLogIn()}
				
			</>
		);
	}
}

export default NavBarLogin;
